export default {
  isLoading(state) {
    return state.isLoading;
  }
};
